import { FC } from 'react';
import { Button, Col, Form, Input, InputNumber, message, Row, Spin } from "antd";
import * as React from "react";
import restful from '../../restful';
import SelectRoleField from '../fields/select-role-field';
import Password from 'antd/lib/input/Password';

interface Prop { id: string | null }

const UserForm: FC<Prop> = ({ id }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = React.useState(false)

	React.useEffect(() => {
		if (id === null) return
		setLoading(true)
		restful.get('users/' + id + "/form")
			.then((res) => {
				form.setFieldsValue(res.data.result.form)
			})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));;
	}, [])

	function onFinish(data: any) {
		setLoading(true)
		restful.request({
			data,
			method: id ? "PUT" : "POST",
			url: id ? `/users/${id}` : "/users"
		}).then((res) => {
			if (id === null) form.resetFields()
			message.success("انجام شد")
		})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));
	}

	return (
		<Spin spinning={loading} >
			<Form form={form} onFinish={onFinish} layout="vertical" autoComplete='off'>
				<Row gutter={16}>

					<Col xs={24} md={12}  >
						<Form.Item name="name" label="نام"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Input />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="role" label="نقش"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<SelectRoleField />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="mobile" label="موبایل"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Input />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="password" label="پسورد"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Password />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="totalCall" label="تعداد تماس"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Input  />
						</Form.Item>
					</Col>

					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">ثبت</Button>
					</Col>
				</Row>
			</Form>
		</Spin>
	)
}

export default UserForm;
